// Step Modal JavaScript
// Handles all step modal functionality including flavor selection, navigation, and form interactions

document.addEventListener('DOMContentLoaded', function() {
  // Initialize step modals for both desktop and mobile
  initializeStepModal('');        // Desktop modal
  initializeStepModal('mobile-'); // Mobile modal
  initializeDragSwipe()
  
});

function initializeStepModal(namePrefix) {
  // Get the device type for this modal instance
  const device = namePrefix === 'mobile-' ? 'mobile' : 'desktop';
  
  // Step Modal Elements
  const continueButton = document.getElementById(namePrefix + 'continue-button');
  const stepModal = document.getElementById(namePrefix + 'step-modal');
  const closeModal = document.getElementById(namePrefix + 'close-modal');
  const closeModalImg = document.querySelector('.step-modal-close-img');
  const backBtn = document.getElementById(namePrefix + 'back-btn');
  const stepPanels = stepModal ? stepModal.querySelectorAll('.step-panel') : [];
  const progressFill = document.getElementById(namePrefix + 'progress-fill');
  const currentStepSpan = document.getElementById(namePrefix + 'current-step');
  const stepOptionBtns = stepModal ? stepModal.querySelectorAll('.step-option-btn') : [];
  const stepContinueBtns = stepModal ? stepModal.querySelectorAll('.step-continue-btn') : [];
  
  // Check if this is a subscribe-gift template
  const isSubscribeGift = stepModal && stepModal.classList.contains('template-product-subscribe-gift');
  
  let currentStep = isSubscribeGift ? 3 : 1; // Start at step 3 (gift note) for subscribe-gift
  const totalSteps = isSubscribeGift ? 1 : 5; // Only 1 step for subscribe-gift
  
  // Skip initialization if modal doesn't exist
  if (!stepModal) return;
  
  // Open modal when Continue is clicked
  if (continueButton) {
    continueButton.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Check if size and variant selectors exist
      const sizeInputs = document.querySelectorAll('input[name="' + namePrefix + 'size"]');
      const variantInputs = document.querySelectorAll('input[name="' + namePrefix + 'variant"]');
      
      // Only validate if the inputs exist
      if (sizeInputs.length > 0) {
        const selectedSize = document.querySelector('input[name="' + namePrefix + 'size"]:checked');
        if (!selectedSize) {
          alert('Please select a size');
          return;
        }
      }
      
      if (variantInputs.length > 0) {
        const selectedVariant = document.querySelector('input[name="' + namePrefix + 'variant"]:checked');
        if (!selectedVariant) {
          alert('Please select a product type');
          return;
        }
      }
      
      // For subscribe-gift templates, open modal immediately without scroll
      if (isSubscribeGift) {
        // window.scrollTo({ top: 0 });
        stepModal.style.display = 'flex';
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
        document.body.classList.add('product-modal-opened')
        currentStep = 3; // Start at gift note step
        updateStepDisplay();
      } else {
        // Scroll to top first, then open the step modal for regular templates
        // window.scrollTo({ top: 0 });
        
        // Small delay to ensure scroll completes before opening modal
        setTimeout(() => {
          stepModal.style.display = 'flex';
          document.body.style.overflow = 'hidden'; // Prevent background scrolling
          document.body.classList.add('product-modal-opened')
          currentStep = 1;
          updateStepDisplay();
          
          // For show_variants products, update the flavor heading immediately when modal opens
          const isShowVariants = stepModal.getAttribute('data-show-variants') === 'true';
          if (isShowVariants) {
            // Small delay to ensure modal data is set
            setTimeout(() => {
              updateFlavorContinueButton();
            }, 100);
          }
        }, 300);
      }
    });
  }
  
  // Close modal function
  function closeStepModal() {
    stepModal.style.display = 'none';
    document.body.style.overflow = 'auto';
    document.body.classList.remove('product-modal-opened')
    currentStep = 1;
    updateStepDisplay();
    resetStepSelections();
  }
  
  // Close modal event listeners
  if (closeModal) {
    closeModal.addEventListener('click', closeStepModal);
  }
  if(closeModalImg){
    closeModalImg.addEventListener('click', closeStepModal);
  }
  // Close modal when clicking outside
  stepModal.addEventListener('click', function(e) {
    if (e.target === stepModal) {
      closeStepModal();
    }
  });
  
  // Back button functionality
  if (backBtn) {
    backBtn.addEventListener('click', function() {
      if (currentStep > 1) {
        currentStep--;
        updateStepDisplay();
      }
    });
  }
  
  // Step option button selection - show content based on selection
  stepOptionBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const currentPanel = this.closest('.step-panel');
      const stepNumber = parseInt(currentPanel.getAttribute('data-step'));
      const value = this.getAttribute('data-value');
      const continueBtn = currentPanel.querySelector('.step-continue-btn');
      
      // Remove selected class from siblings
      const siblings = this.parentElement.querySelectorAll('.step-option-btn');
      siblings.forEach(sibling => sibling.classList.remove('selected'));
      
      // Add selected class to clicked button
      this.classList.add('selected');
      
      // Update button text based on selection (but not for subscribe-gift templates)
      if (!isSubscribeGift) {
        if (value === 'yes') {
          if (continueBtn) {
            continueBtn.textContent = 'Continue';
            continueBtn.classList.add('active-state');
          }
        } else if (value === 'no') {
          if (continueBtn) {
            // Set specific text based on step
            if (stepNumber === 2) {
              continueBtn.textContent = 'Ship ASAP';
            } else if (stepNumber === 3) {
              continueBtn.textContent = 'No gift note';
            } else if (stepNumber === 4) {
              continueBtn.textContent = 'No print';
            } else {
              continueBtn.textContent = 'Continue';
            }
            continueBtn.classList.remove('active-state');
          }
        }
      }
      
      // Handle step-specific logic
      if (stepNumber === 2) {
        // Step 2: Date picker logic
        const dateContainer = currentPanel.querySelector('.date-picker-container');
        const dateInput = currentPanel.querySelector('.date-picker');
        if (value === 'yes') {
          dateContainer.style.display = 'block';
          // Disable continue button until date is selected
          if (continueBtn) {
            continueBtn.disabled = true;
            continueBtn.classList.remove('active-state');
          }
          // Don't auto-advance, wait for continue button
        } else {
          dateContainer.style.display = 'none';
          // Clear date input when "No" is selected
          if (dateInput) {
            dateInput.value = '';
          }
          // Enable continue button for "No" selection
          if (continueBtn) {
            continueBtn.disabled = false;
            continueBtn.classList.add('active-state');
          }
          // No auto-advance for "No" - user must click continue
        }
      } else if (stepNumber === 3) {
        // Step 3: Gift note logic
        const giftContainer = currentPanel.querySelector('.gift-note-container');
        const giftNoteInput = currentPanel.querySelector('.gift-note-text');
        if (value === 'yes') {
          giftContainer.style.display = 'block';
          // Disable continue button until gift note is entered
          if (continueBtn) {
            continueBtn.disabled = true;
            continueBtn.classList.remove('active-state');
          }
          // Don't auto-advance, wait for continue button
        } else {
          giftContainer.style.display = 'none';
          // Clear gift note text when "No" is selected
          if (giftNoteInput) {
            giftNoteInput.value = '';
          }
          // Enable continue button for "No" selection
          if (continueBtn) {
            continueBtn.disabled = false;
            continueBtn.classList.add('active-state');
          }
          
          // For subscribe-gift template, auto add to cart when "No" is selected
          if (isSubscribeGift) {
            // setTimeout(() => {
            //   addToCartFromModal();
            // }, 500);
          } else {
            // No auto-advance for "No" - user must click continue
          }
        }
      } else if (stepNumber === 4) {
        // Step 4: Upload logic
        const uploadContainer = currentPanel.querySelector('.upload-container');
        const customImgaes = currentPanel.querySelectorAll('.custom-print-image');
        const customMsg = currentPanel.querySelector('.custom-image-selection-msg');
        const customImgaeactive = currentPanel.querySelector('.custom-print-image.active');
        if (value === 'yes') {
          uploadContainer.style.display = 'block';
          // Check if file is already uploaded
          const printFileInput = document.getElementById(namePrefix + 'print_file');
          const btn_text = document.getElementById(namePrefix + 'step-modal').dataset.btn;
          const hasFile = printFileInput && printFileInput.value;
          if (hasFile || customImgaeactive) {
            // File already uploaded, enable continue button
            continueBtn.disabled = false;
            continueBtn.style.background = 'white';
            continueBtn.style.color = '#333';
            continueBtn.style.borderColor = '#333';
            continueBtn.innerHTML = 'Continue';
          } else {
            // No file uploaded, disable continue button
            continueBtn.disabled = true;
            continueBtn.style.background = '#f0f0f0';
            continueBtn.style.color = '#999';
            continueBtn.style.borderColor = '#ccc';
            continueBtn.textContent = btn_text;
          }
          // Don't auto-advance, wait for continue button
        } else {
          uploadContainer.style.display = 'none';
          // Enable continue button for "No" selection
          continueBtn.disabled = false;
          continueBtn.classList.add('active-state');
          // customImgaes.forEach(customImage => {
          //   customImage.classList.remove('active');
          // });
          // if(customMsg) customMsg.style.display = 'none';
          // Auto-advance for "No"
          // setTimeout(() => {
          //   currentStep++;
          //   updateStepDisplay();
          // }, 500);
        }
        
        // Update price when print selection changes (if we're on final step)
        if (currentStep === totalSteps || (stepModal.getAttribute('data-variety-pack') === 'true' && currentStep === totalSteps - 1)) {
          setTimeout(() => {
            updateAddToCartPrice();
          }, 100);
        }
      } else {
        // Other steps - auto-advance
        setTimeout(() => {
          if (currentStep < totalSteps) {
            currentStep++;
            updateStepDisplay();
          } else {
            closeStepModal();
            alert('Process completed!');
          }
        }, 500);
      }
    });
  });
  
  // Step continue button functionality
  stepContinueBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const currentPanel = this.closest('.step-panel');
      const stepNumber = parseInt(currentPanel.getAttribute('data-step'));
      
      // Handle flavor continue button (step 1)
      if (stepNumber === 1) {
        // Only advance if required number of flavors are selected
        const totalSelected = getTotalSelectedFlavors();
        
        // Get dynamic max selection for show_variants products
        let dynamicMaxSelection = maxSelection;
        const isShowVariants = stepModal.getAttribute('data-show-variants') === 'true';
        
        if (isShowVariants) {
          const selectedVariantOption = stepModal.getAttribute('data-selected-variant-option');
          if (selectedVariantOption) {
            dynamicMaxSelection = getMacaronsForVariant(selectedVariantOption);
          }
        }
        
        if (totalSelected === dynamicMaxSelection) {
          currentStep++;
          updateStepDisplay();
        }
        return;
      }
      
      // For subscribe-gift template, step 3 (gift note) should add to cart directly
      if (isSubscribeGift && stepNumber === 3) {
        addToCartFromModal();
        return;
      }
      
      // For other steps, advance normally
      if (currentStep < totalSteps) {
        currentStep++;
        updateStepDisplay();
      } else {
        // Final step - add to cart with collected data
        addToCartFromModal();
      }
    });
  });
  
  // Update step display
  function updateStepDisplay() {
    // Check if variety pack is selected
    const isVarietyPack = stepModal.getAttribute('data-variety-pack') === 'true';
    
    // Update add to cart button price when reaching final step
    if (currentStep === totalSteps || (isVarietyPack && currentStep === totalSteps - 1)) {
      updateAddToCartPrice();
    }
    
    if (isSubscribeGift) {
      // For subscribe-gift, show only step 3 (gift note)
      // Update progress bar to 100%
      if (progressFill) {
        progressFill.style.width = '100%';
      }
      
      // Update step counter to show 1 of 1
      if (currentStepSpan) {
        currentStepSpan.textContent = '1';
      }
      
      // Update total steps display
      const totalStepsSpan = stepModal.querySelector('#' + namePrefix + 'total-steps');
      if (totalStepsSpan) {
        totalStepsSpan.textContent = '1';
      }
      
      // Hide back button for subscribe-gift
      if (backBtn) {
        backBtn.style.visibility = 'hidden';
      }
      
      // Show only step 3 panel (gift note)
      stepPanels.forEach((panel, index) => {
        panel.classList.toggle('active', index + 1 === 3);
      });
      
      // Update the step 3 continue button to be "Add to cart" with price
      const step3Panel = stepModal.querySelector('.step-panel[data-step="3"]');
      if (step3Panel) {
        const continueBtn = step3Panel.querySelector('.step-continue-btn');
        if (continueBtn) {
          continueBtn.classList.add('add-to-cart-btn');
          // Update with price from subscription selection
          updateSubscribeGiftAddToCartPrice(continueBtn);
        }
      }
    } else if (isVarietyPack) {
      // For variety pack, skip step 1 and adjust display
      const adjustedTotalSteps = 4;
      const adjustedCurrentStep = currentStep === 1 ? 2 : currentStep;
      
      // Update progress bar
      const progressPercent = ((adjustedCurrentStep - 1) / adjustedTotalSteps) * 100;
      if (progressFill) {
        progressFill.style.width = progressPercent + '%';
      }
      
      // Update step counter (show as 1 of 4 when on step 2)
      if (currentStepSpan) {
        currentStepSpan.textContent = adjustedCurrentStep - 1;
      }
      
      // Update total steps display
      const totalStepsSpan = stepModal.querySelector('#' + namePrefix + 'total-steps');
      if (totalStepsSpan) {
        totalStepsSpan.textContent = adjustedTotalSteps;
      }
      
      // Show/hide back button (hide when on step 2 for variety pack)
      if (backBtn) {
        backBtn.style.visibility = currentStep > 2 ? 'visible' : 'hidden';
      }
      
      // Show current step panel, but skip step 1
      stepPanels.forEach((panel, index) => {
        if (index + 1 === 1) {
          // Hide step 1 for variety pack
          panel.classList.remove('active');
        } else {
          panel.classList.toggle('active', index + 1 === currentStep);
        }
      });
      
      // If we're trying to show step 1, jump to step 2 instead
      if (currentStep === 1) {
        currentStep = 2;
        // Recursively call to update display with step 2
        setTimeout(() => updateStepDisplay(), 0);
        return;
      }
    } else {
      // Normal flow for build my box
      // Update progress bar
      const progressPercent = (currentStep / totalSteps) * 100;
      if (progressFill) {
        progressFill.style.width = progressPercent + '%';
      }
      
      // Update step counter
      if (currentStepSpan) {
        currentStepSpan.textContent = currentStep;
      }
      
      // Update total steps display
      const totalStepsSpan = stepModal.querySelector('#' + namePrefix + 'total-steps');
      if (totalStepsSpan) {
        totalStepsSpan.textContent = totalSteps;
      }
      
      // Show/hide back button
      if (backBtn) {
        backBtn.style.visibility = currentStep > 1 ? 'visible' : 'hidden';
      }
      
      // Show current step panel
      stepPanels.forEach((panel, index) => {
        panel.classList.toggle('active', index + 1 === currentStep);
      });
    }
  }
  
  // Reset step selections
  function resetStepSelections() {
    // Reset all step option buttons
    stepOptionBtns.forEach(btn => {
      btn.classList.remove('selected');
    });
    
    // Reset step 2 (date picker)
    const step2Panel = stepModal.querySelector('.step-panel[data-step="2"]');
    if (step2Panel) {
      const dateContainer = step2Panel.querySelector('.date-picker-container');
      const dateInput = step2Panel.querySelector('.date-picker');
      const continueBtn = step2Panel.querySelector('.step-continue-btn');
      
      if (dateContainer) dateContainer.style.display = 'none';
      if (dateInput) {
        dateInput.value = '';
        dateInput.disabled = true;
        dateInput.style.opacity = '0.5';
        dateInput.style.cursor = 'not-allowed';
      }
      if (continueBtn) {
        continueBtn.textContent = 'Ship ASAP';
        continueBtn.disabled = false;
        continueBtn.classList.remove('active-state');
      }
    }
    
    // Reset step 3 (gift note)
    const step3Panel = stepModal.querySelector('.step-panel[data-step="3"]');
    if (step3Panel) {
      const giftContainer = step3Panel.querySelector('.gift-note-container');
      const giftNoteInput = step3Panel.querySelector('.gift-note-text');
      const continueBtn = step3Panel.querySelector('.step-continue-btn');
      
      if (giftContainer) giftContainer.style.display = 'none';
      if (giftNoteInput) {
        giftNoteInput.value = '';
        giftNoteInput.disabled = true;
        giftNoteInput.style.opacity = '0.5';
        giftNoteInput.style.cursor = 'not-allowed';
      }
      if (continueBtn) {
        continueBtn.textContent = 'No gift note';
        continueBtn.disabled = false;
        continueBtn.classList.remove('active-state');
      }
    }
    
    // Reset step 4 (print/upload)
    const step4Panel = stepModal.querySelector('.step-panel[data-step="4"]');
    if (step4Panel) {
      const uploadContainer = step4Panel.querySelector('.upload-container');
      const continueBtn = step4Panel.querySelector('.step-continue-btn');
      const printFileInput = document.getElementById(namePrefix + 'print_file');
      const fileInput = document.getElementById(namePrefix + 'print-file-input');
      const fileLabel = document.querySelector(`label[for="${namePrefix}print-file-input"]`);
      const prevDiv = document.querySelector(`#${namePrefix}step-modal .prev-div`);
      const fileLabelcustom = document.querySelector(`.custom-print-image`);
      const allCustomPrint = document.querySelector(`#${namePrefix}step-modal .custom-print-image.active`);
      const centerText = document.querySelector(`#${namePrefix}step-modal`).dataset.center;
      const leftText = document.querySelector(`#${namePrefix}step-modal`).dataset.left;
      const rightText = document.querySelector(`#${namePrefix}step-modal`).dataset.right;
      if (uploadContainer) uploadContainer.style.display = 'none';
      if (printFileInput) printFileInput.value = '';
      if (fileInput) fileInput.value = '';
      if (fileLabel) fileLabel.innerHTML = 'Choose File';
      if (fileLabelcustom) fileLabel.innerHTML = `<span class="not-clickable-link">${leftText} </span><span>${centerText}</span><span class="not-clickable-link"> ${rightText}</span>`;
      if (allCustomPrint) allCustomPrint.classList.remove('active');
      if (prevDiv) {
        prevDiv.innerHTML = '';
        prevDiv.style.border = '';
        prevDiv.style.background = '';
        prevDiv.style.display = 'none';
      }
      if (continueBtn) {
        continueBtn.textContent = 'No print';
        continueBtn.disabled = false;
        continueBtn.classList.remove('active-state');
      }
    }
    
    // Reset flavor selections
    const flavorInputs = stepModal.querySelectorAll('.qtycontrol input[type="text"]');
    flavorInputs.forEach(input => {
      input.value = '0';
    });
    
    // Reset flavor continue button
    const flavorContinueBtn = stepModal.querySelector('#' + namePrefix + 'flavor-continue');
    if (flavorContinueBtn) {
      updateFlavorContinueButton();
    }
    
    // Reset quantity input
    const quantityInput = stepModal.querySelector('.quantity-input');
    if (quantityInput) {
      quantityInput.value = '1';
    }
  }
  
  // Quantity selector functionality for final step
  const quantityInput = stepModal.querySelector('.quantity-input');
  const minusBtn = stepModal.querySelector('.quantity-btn.minus');
  const plusBtn = stepModal.querySelector('.quantity-btn.plus');
  
  if (minusBtn && quantityInput) {
    minusBtn.addEventListener('click', function() {
      const currentValue = parseInt(quantityInput.value);
      const minValue = parseInt(quantityInput.getAttribute('min')) || 1;
      if (currentValue > minValue) {
        quantityInput.value = currentValue - 1;
        updateAddToCartPrice(); // Update price when quantity changes
      }
    });
  }
  
  if (plusBtn && quantityInput) {
    plusBtn.addEventListener('click', function() {
      const currentValue = parseInt(quantityInput.value);
      const maxValue = parseInt(quantityInput.getAttribute('max')) || 1000;
      if (currentValue < maxValue) {
        quantityInput.value = currentValue + 1;
        updateAddToCartPrice(); // Update price when quantity changes
      }
    });
  }
  
  // Also listen for direct input changes
  if (quantityInput) {
    quantityInput.addEventListener('input', function() {
      updateAddToCartPrice();
    });
  }
  
  // Flavor quantity selector functionality
  const flavorControls = stepModal.querySelectorAll('.qtycontrol');
  // Get box count from data attribute, fallback to 24
  const maxSelection = parseInt(stepModal.getAttribute('data-box-count')) || 24;
  const flavorContinueBtn = stepModal.querySelector('#' + namePrefix + 'flavor-continue');
  
  flavorControls.forEach(control => {
    const minusBtn = control.querySelector('.qtycontrol__actions.is_minus');
    const plusBtn = control.querySelector('.qtycontrol__actions.is_plus');
    const input = control.querySelector('input[type="text"]');
    
    if (minusBtn && plusBtn && input) {
      // Enable the input field for direct editing
      input.removeAttribute('readonly');
      input.removeAttribute('disabled');
      
      // Minus button functionality
      minusBtn.addEventListener('click', function() {
        const currentValue = parseInt(input.value) || 0;
        if (currentValue > 0) {
          input.value = currentValue - 1;
          updateFlavorContinueButton();
        }
      });
      
      // Plus button functionality
      plusBtn.addEventListener('click', function() {
        const currentValue = parseInt(input.value) || 0;
        const totalSelected = getTotalSelectedFlavors();
        
        // Get dynamic max selection for show_variants products
        let dynamicMaxSelection = maxSelection;
        const isShowVariants = stepModal.getAttribute('data-show-variants') === 'true';
        
        if (isShowVariants) {
          const selectedVariantOption = stepModal.getAttribute('data-selected-variant-option');
          if (selectedVariantOption) {
            dynamicMaxSelection = getMacaronsForVariant(selectedVariantOption);
          }
        }
        
        if (totalSelected < dynamicMaxSelection) {
          input.value = currentValue + 1;
          updateFlavorContinueButton();
        }
      });
      
      // Direct input functionality with validation
      input.addEventListener('input', function() {
        validateAndUpdateFlavorInput(this);
      });
      
      // Also handle paste events
      input.addEventListener('paste', function() {
        setTimeout(() => {
          validateAndUpdateFlavorInput(this);
        }, 10);
      });
      
      // Handle blur event to ensure valid value when user leaves the field
      input.addEventListener('blur', function() {
        validateAndUpdateFlavorInput(this);
      });
    }
  });
  
  // Function to validate and update flavor input
  function validateAndUpdateFlavorInput(input) {
    let value = parseInt(input.value) || 0;
    
    // Get dynamic max selection for show_variants products
    let dynamicMaxSelection = maxSelection;
    const isShowVariants = stepModal.getAttribute('data-show-variants') === 'true';
    
    if (isShowVariants) {
      const selectedVariantOption = stepModal.getAttribute('data-selected-variant-option');
      if (selectedVariantOption) {
        dynamicMaxSelection = getMacaronsForVariant(selectedVariantOption);
      }
    }
    
    // Ensure value is not negative
    if (value < 0) {
      value = 0;
    }
    
    // Calculate total selected from other inputs (excluding current input)
    let totalFromOthers = 0;
    const allFlavorInputs = stepModal.querySelectorAll('.qtycontrol input[type="text"]');
    allFlavorInputs.forEach(otherInput => {
      if (otherInput !== input) {
        totalFromOthers += parseInt(otherInput.value) || 0;
      }
    });
    
    // Calculate maximum allowed for this input
    const maxAllowedForThis = dynamicMaxSelection - totalFromOthers;
    
    // If the entered value exceeds what's allowed
    if (value > maxAllowedForThis) {
      // If there's at least 1 slot available, set to 1, otherwise set to 0
      if (maxAllowedForThis > 0) {
        value = Math.min(1, maxAllowedForThis);
      } else {
        value = 0;
      }
    }
    
    // Update the input value
    input.value = value;
    
    // Update the continue button
    updateFlavorContinueButton();
    
    console.log('Validated flavor input:', {
      inputValue: value,
      totalFromOthers: totalFromOthers,
      maxAllowedForThis: maxAllowedForThis,
      dynamicMaxSelection: dynamicMaxSelection
    });
  }
  
  // Get total selected flavors
  function getTotalSelectedFlavors() {
    let total = 0;
    const flavorInputs = stepModal.querySelectorAll('.qtycontrol input[type="text"]');
    flavorInputs.forEach(input => {
      total += parseInt(input.value) || 0;
    });
    return total;
  }
  
  // Update flavor continue button
  function updateFlavorContinueButton() {
    if (!flavorContinueBtn) return;
    
    const totalSelected = getTotalSelectedFlavors();
    
    // For show_variants products, get dynamic macaron count based on selected variant
    let dynamicMaxSelection = maxSelection;
    
    // Check if this is a show_variants product
    const isShowVariants = stepModal.getAttribute('data-show-variants') === 'true';
    
    if (isShowVariants) {
      const selectedVariantOption = stepModal.getAttribute('data-selected-variant-option');
      if (selectedVariantOption) {
        dynamicMaxSelection = getMacaronsForVariant(selectedVariantOption);
        console.log('Using dynamic macaron count:', dynamicMaxSelection, 'for variant:', selectedVariantOption);
      } else {
        console.log('No selected variant option found in modal data');
      }
    }
    
    // Update the heading to show dynamic progress
    const flavorHeading = stepModal.querySelector('#' + namePrefix + 'flavor-heading');
    if (flavorHeading) {
      flavorHeading.textContent = `Select ${totalSelected}/${dynamicMaxSelection} macarons`;
      console.log('Updated flavor heading to:', flavorHeading.textContent);
    }
    
    flavorContinueBtn.textContent = `Selection: ${totalSelected}/${dynamicMaxSelection}`;
    
    if (totalSelected === dynamicMaxSelection) {
      flavorContinueBtn.textContent = 'Continue';
      flavorContinueBtn.disabled = false;
      flavorContinueBtn.classList.add('active-state');
      // Remove inline styles to let schema CSS take over
      flavorContinueBtn.style.background = '';
      flavorContinueBtn.style.color = '';
      flavorContinueBtn.style.borderColor = '';
      
      // Auto-scroll to continue button on desktop when selection is complete
      if (device === 'desktop') {
        setTimeout(() => {
          flavorContinueBtn.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'center' 
          });
        }, 300);
      }
    } else {
      flavorContinueBtn.disabled = true;
      flavorContinueBtn.classList.remove('active-state');
      flavorContinueBtn.style.background = '#f0f0f0';
      flavorContinueBtn.style.color = '#999';
      flavorContinueBtn.style.borderColor = '#ccc';
    }
  }
  
  // Initialize the flavor continue button state
  updateFlavorContinueButton();
  
  // File upload functionality
  initializeFileUpload(namePrefix);
  
  // Initialize step 4 default state
  initializeStep4DefaultState(namePrefix);
  
  // Initialize date picker functionality
  initializeDatePicker(namePrefix);
  
  // Initialize gift note functionality
  initializeGiftNote(namePrefix);

    // Initialize custom print image functionality
  initializeCustomPrintImages(namePrefix);

  
  // Keyboard navigation
  document.addEventListener('keydown', function(e) {
    if (stepModal.style.display === 'flex') {
      if (e.key === 'Escape') {
        closeStepModal();
      }
    }
  });
  
  // Function to update add to cart button price
  function updateAddToCartPrice() {
    const addToCartBtn = stepModal.querySelector('.add-to-cart-btn');
    if (!addToCartBtn) return;
    
    // Get the current quantity
    const quantityInput = stepModal.querySelector('.quantity-input');
    const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
    
    // Determine which variant to use based on selections
    let variantId, price;
    
    // Check if this is a show_variants product
    const isShowVariants = stepModal.getAttribute('data-show-variants') === 'true';
    
    // Check if variety pack is selected
    const isVarietyPack = stepModal.getAttribute('data-variety-pack') === 'true';
    
    // Check if print is selected
    const step4Panel = stepModal.querySelector('.step-panel[data-step="4"]');
    const printYesBtn = step4Panel ? step4Panel.querySelector('.step-option-btn[data-value="yes"].selected') : null;
    const isPrintSelected = printYesBtn !== null;
    
    if (isShowVariants) {
      // Handle show_variants products
      if (isPrintSelected) {
        // Print on macarons selected - use print product variants from modal data
        if (isVarietyPack) {
          variantId = stepModal.getAttribute('data-print-variety-variant');
          price = parseInt(stepModal.getAttribute('data-print-variety-price')) || 0;
        } else {
          variantId = stepModal.getAttribute('data-print-build-variant');
          price = parseInt(stepModal.getAttribute('data-print-build-price')) || 0;
        }
      } else {
        // No print selected - use the selected variant ID from modal data
        variantId = stepModal.getAttribute('data-selected-variant-id');
        
        // Get price from the appropriate radio box
        if (isVarietyPack) {
          const varietyBox = document.querySelector('.radio-box[data-variant="variety"]');
          price = varietyBox ? parseInt(varietyBox.getAttribute('data-price')) || 0 : 0;
        } else {
          const buildBox = document.querySelector('.radio-box[data-variant="build"]');
          price = buildBox ? parseInt(buildBox.getAttribute('data-price')) || 0 : 0;
        }
      }
    } else {
      // Handle regular products (existing logic)
      if (isPrintSelected) {
        // Print on macarons selected - use print product variants
        const uploadContainer = step4Panel.querySelector('.upload-container');
        if (uploadContainer) {
          if (isVarietyPack) {
            // Use variety set print variant
            variantId = uploadContainer.getAttribute('data-print-variety-variant');
            price = parseInt(uploadContainer.getAttribute('data-print-variety-price')) || 0;
          } else {
            // Use build your set print variant
            variantId = uploadContainer.getAttribute('data-print-build-variant');
            price = parseInt(uploadContainer.getAttribute('data-print-build-price')) || 0;
          }
        }
      } else {
        // No print selected - use normal product variants
        if (isVarietyPack) {
          // Use variety pack variant - get from radio box data attributes
          const varietyBox = document.querySelector('.radio-box[data-variant="variety"]');
          if (varietyBox) {
            variantId = varietyBox.getAttribute('data-variant-id');
            price = parseInt(varietyBox.getAttribute('data-price')) || 0;
          }
        } else {
          // Use build my box variant - get from radio box data attributes
          const buildBox = document.querySelector('.radio-box[data-variant="build"]');
          if (buildBox) {
            variantId = buildBox.getAttribute('data-variant-id');
            price = parseInt(buildBox.getAttribute('data-price')) || 0;
          }
        }
      }
    }
    
    // Update the product selector with the correct variant ID
    const productSelect = document.querySelector('#product-select');
    if (productSelect && variantId) {
      productSelect.value = variantId;
    }
    
    // Calculate total price (price is already in cents)
    const totalPrice = (price * quantity) / 100; // Convert to dollars
    
    // Format price
    const formattedPrice = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(totalPrice);
    
    // Update button text
    addToCartBtn.textContent = `Add to cart | ${formattedPrice.split('.')[0]}`;
  }
  
  // Function to collect form data and add to cart
  function addToCartFromModal() {
    // Check if this is a subscribe-gift template
    const isSubscribeGift = stepModal.classList.contains('template-product-subscribe-gift') || 
                           document.body.classList.contains('template-product-subscribe-gift') ||
                           window.location.pathname.includes('subscribe-gift');
    
    if (isSubscribeGift) {
      // For subscribe-gift templates, use the stored selection data
      if (window.subscribeGiftSelection) {
        const { variantId, sellingPlan, isAutoRenew, cycle } = window.subscribeGiftSelection;
        const properties = {};
        
        // Collect gift note
        const giftNoteInput = stepModal.querySelector('.gift-note-text');
        if (giftNoteInput && giftNoteInput.value.trim()) {
          properties['Gift Note'] = giftNoteInput.value.trim();
        }
        
        console.log('Adding subscribe-gift to cart:', {
          variantId,
          quantity: 1,
          properties,
          sellingPlan
        });
        
        // Close modal first
        closeStepModal();
        
        // Add to cart with selling plan
        if (typeof addToCart === 'function') {
          addToCart(variantId, 1, properties, sellingPlan);
        } else {
          console.error('addToCart function not found');
        }
        return;
      } else {
        console.error('Subscribe-gift selection data not found');
        console.log('Available window properties:', Object.keys(window));
        alert('Please select a subscription option first');
        return;
      }
    }
    
    // Original logic for non-subscribe-gift templates
    // Get the current quantity
    const quantity = stepModal.querySelector('.quantity-input')?.value || 1;
    const properties = {};
    
    // Check if this is a show_variants product
    const isShowVariants = stepModal.getAttribute('data-show-variants') === 'true';
    
    // Check if variety pack is selected
    const isVarietyPack = stepModal.getAttribute('data-variety-pack') === 'true';
    
    // Determine which variant to use based on selections (same logic as updateAddToCartPrice)
    let variantId;
    
    // Check if print is selected
    const step4Panel = stepModal.querySelector('.step-panel[data-step="4"]');
    const printYesBtn = step4Panel ? step4Panel.querySelector('.step-option-btn[data-value="yes"].selected') : null;
    const isPrintSelected = printYesBtn !== null;
    
    if (isShowVariants) {
      // Handle show_variants products
      if (isPrintSelected) {
        // Print on macarons selected - use print product variants from modal data
        if (isVarietyPack) {
          variantId = stepModal.getAttribute('data-print-variety-variant');
        } else {
          variantId = stepModal.getAttribute('data-print-build-variant');
        }
      } else {
        // No print selected - use the selected variant ID from modal data
        variantId = stepModal.getAttribute('data-selected-variant-id');
      }
    } else {
      // Handle regular products (existing logic)
      if (isPrintSelected) {
        // Print on macarons selected - use print product variants
        const uploadContainer = step4Panel.querySelector('.upload-container');
        if (uploadContainer) {
          if (isVarietyPack) {
            // Use variety set print variant
            variantId = uploadContainer.getAttribute('data-print-variety-variant');
          } else {
            // Use build your set print variant
            variantId = uploadContainer.getAttribute('data-print-build-variant');
          }
        }
      } else {
        // No print selected - use normal product variants
        if (isVarietyPack) {
          // Use variety pack variant - get from radio box data attributes
          const varietyBox = document.querySelector('.radio-box[data-variant="variety"]');
          if (varietyBox) {
            variantId = varietyBox.getAttribute('data-variant-id');
          }
        } else {
          // Use build my box variant - get from radio box data attributes
          const buildBox = document.querySelector('.radio-box[data-variant="build"]');
          if (buildBox) {
            variantId = buildBox.getAttribute('data-variant-id');
          }
        }
      }
    }
    
    // Validate that we have a variant ID
    if (!variantId) {
      alert('Unable to determine product variant. Please try again.');
      return;
    }
    
    if (!isVarietyPack) {
      // Collect flavor selections for build my box
      const flavorInputs = stepModal.querySelectorAll('.qtycontrol input[type="text"]');
      flavorInputs.forEach(input => {
        const quantity = parseInt(input.value) || 0;
        if (quantity > 0) {
          // Get flavor name from the input's id attribute or closest label
          const flavorName = input.getAttribute('id') || 
                           input.closest('.flavor')?.querySelector('.flavor__label')?.textContent?.trim() ||
                           input.getAttribute('name') ||
                           'Unknown_Flavor';
          
          // Clean up flavor name for property key
          const cleanFlavorName = flavorName.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_]/g, '');
          properties[cleanFlavorName] = quantity;
        }
      });
    }
    
    // Collect event date
    const dateInput = stepModal.querySelector('.date-picker');
    if (dateInput && dateInput.value) {
      properties['Event date'] = dateInput.value;
    }
    
    // Collect gift note
    const giftNoteInput = stepModal.querySelector('.gift-note-text');
    if (giftNoteInput && giftNoteInput.value.trim()) {
      properties['Gift note'] = giftNoteInput.value.trim();
    }
    
    // Collect print file - only if print is explicitly selected as "yes"
    if (isPrintSelected) {
      const printFileInput = document.getElementById(namePrefix + 'print_file');
      if (printFileInput && printFileInput.value) {
        properties['Print File'] = printFileInput.value;
      }
    }
    
    console.log('Adding to cart:', {
      variantId,
      quantity: parseInt(quantity),
      properties
    });
    
    // Close modal first
    closeStepModal();
    
    // Add to cart with properties
    if (typeof addToCart === 'function') {
      addToCart(variantId, parseInt(quantity), properties);
    } else {
      console.error('addToCart function not found');
    }
  }
}

// Initialize step 4 with no default selection and "No print" button
function initializeStep4DefaultState(namePrefix) {
  const stepModal = document.getElementById(namePrefix + 'step-modal');
  if (!stepModal) return;
  
  const step4Panel = stepModal.querySelector('.step-panel[data-step="4"]');
  if (!step4Panel) return;
  
  const continueBtn = step4Panel.querySelector('.step-continue-btn');
  if (continueBtn) {
    // Set initial state - "No print" button enabled by default
    continueBtn.textContent = 'No print';
    continueBtn.disabled = false;
    continueBtn.style.background = 'white';
    continueBtn.style.color = '#333';
    continueBtn.style.borderColor = '#333';
  }
}

// File upload functionality
function initializeFileUpload(namePrefix) {
  const fileInput = document.getElementById(namePrefix + 'print-file-input');
  if (!fileInput) return;
  
  // Dropbox token management
  var url = "https://api.dropbox.com/oauth2/token",
      newToken = "";

  function getCookie(e) {
    const o = `; ${document.cookie}`.split(`; ${e}=`);
    if (2 === o.length) return o.pop().split(";").shift()
  }

  if (getCookie("token_drop") && "" != getCookie("token_drop")) {
    newToken = getCookie("token_drop");
  } else {
    var xhr = new XMLHttpRequest;
    xhr.open("POST", url),
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"),
    xhr.setRequestHeader("Authorization", "Basic aXhsNHgxeW5yZDRsN2doOjJnMDE5MjFoNHN0eTF2NA=="),
    xhr.onreadystatechange = function() {
      if (4 === xhr.readyState) {
        console.log(xhr.status),
        newToken = JSON.parse(xhr.responseText).access_token;
        var e = new Date,
            o = e.getTime();
        o += 36e5,
        e.setTime(o),
        document.cookie = "token_drop=" + newToken + "; expires=" + e.toUTCString() + "; path=/"
      }
    };
    var data = "grant_type=refresh_token&refresh_token=LIW99LsQQuYAAAAAAAAAASJ4rGgai83TomMYcLSPAO-hUGHASUJkBzEpU-ZUPP3T";
    xhr.send(data)
  }

  async function postData(e = "", o = {}) {
    return (await fetch(e, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        Authorization: "Bearer " + newToken,
        "Content-Type": "application/json"
      },
      redirect: "follow",
      referrerPolicy: "no-referrer",
      body: JSON.stringify(o)
    })).json()
  }
  
  function drop(e, name) {
    var o = e,
        a = new XMLHttpRequest;

    a.upload.onprogress = function(e) {
      var o = parseInt(100 * e.loaded / e.total);
      document.querySelector(`label[for="${namePrefix}print-file-input"]`).innerHTML = o + "% uploaded"
    };

    a.onload = function() {
      if (200 === a.status) {
        var e = JSON.parse(a.response);
        console.log(e),
        document.querySelector(`label[for="${namePrefix}print-file-input"]`).innerHTML = "File uploaded!"
        postData("https://api.dropboxapi.com/2/sharing/create_shared_link_with_settings", {
          path: e.path_lower
        }).then(e => {
          var reader = new FileReader();
          reader.readAsDataURL(o); 
          
          reader.onloadend = function() {
            var base64data = reader.result;   
            const prevDiv = document.querySelector(`#${namePrefix}step-modal .prev-div`);
            if (prevDiv) {
              prevDiv.innerHTML = `<img style="margin-bottom: 0px; width: 100%; height: auto;" src="${base64data}" alt="image">`;
              prevDiv.style.border = '0';
              prevDiv.style.background = 'none';
              let parent_div = prevDiv.closest('.step-panel');
              let customPrints = parent_div.querySelectorAll('.custom-print-image');
              let uploadPreview = parent_div.querySelector('.upload-preview-container');
              let custom_msg = parent_div.querySelector('.custom-image-selection-msg');
              let btnCt = parent_div.querySelector('.step-continue-btn');
              let stepYes = parent_div.querySelector('.step-option-btn[data-value="yes"]');
              customPrints.forEach(print =>{
                print.classList.remove('active');
              });
              if(uploadPreview) uploadPreview.classList.remove('not-to-show-child');
              if(custom_msg) custom_msg.style.display = 'none';
              if(stepYes) stepYes.click();
              if(btnCt) btnCt.innerHTML = 'Continue'
            }
            const printFileInput = document.getElementById(namePrefix + 'print_file');
            if (printFileInput) {
              printFileInput.value = e.error ? e.error.shared_link_already_exists.metadata.url : e.url;
            }
            
            // Enable continue button when file is uploaded
            const stepModal = document.getElementById(namePrefix + 'step-modal');
            if (stepModal) {
              const step4Panel = stepModal.querySelector('.step-panel[data-step="4"]');
              const continueBtn = step4Panel ? step4Panel.querySelector('.step-continue-btn') : null;
              if (continueBtn) {
                continueBtn.disabled = false;
                continueBtn.style.background = 'white';
                continueBtn.style.color = '#333';
                continueBtn.style.borderColor = '#333';
              }
            }
          }
          console.log(e.error ? e.error.shared_link_already_exists.metadata.url : e.url)
        })
      }
    };

    a.open("POST", "https://content.dropboxapi.com/2/files/upload"),
    a.setRequestHeader("Authorization", "Bearer " + newToken),
    a.setRequestHeader("Content-Type", "application/octet-stream"),
    a.setRequestHeader("Dropbox-API-Arg", JSON.stringify({
      path: "/" + name,
      mode: "add",
      autorename: !0,
      mute: !1
    })),
    a.send(o)
  }

  // File input change event
  fileInput.addEventListener("change", () => {
    const files = fileInput.files;
    var done = function (url) {      
      console.log(fileInput.value);
    };

    if (files && files.length > 0) {
      let file = files[0];
      drop(file, file.name);
      reader = new FileReader();
      reader.onload = function (e) {
        done(reader.result);
      };
      reader.readAsDataURL(file);
    }
  });
}

// Function to update subscribe-gift add to cart button price
function updateSubscribeGiftAddToCartPrice(continueBtn) {
  if (!continueBtn || !window.subscribeGiftSelection) {
    continueBtn.textContent = 'Add to cart';
    return;
  }
  
  // Get price from subscription selection data
  const subscriptionData = getSubscriptionData();
  if (!subscriptionData) {
    continueBtn.textContent = 'Add to cart';
    return;
  }
  
  const { selectedVariant, cycle } = window.subscribeGiftSelection;
  let price = 0;
  
  // Get price based on selected variant and cycle
  if (selectedVariant === 'variety') {
    // Variety Pack - use subscription variants
    const subscriptionKey = cycle; // e.g., "three_months", "six_months", "twelve_months"
    if (subscriptionData[subscriptionKey]) {
      price = subscriptionData[subscriptionKey].price || 0;
    }
  } else {
    // Build my Box - use toggle variants
    const oneTimeKey = 'toggle_' + cycle; // e.g., "toggle_three_months"
    if (subscriptionData[oneTimeKey]) {
      price = subscriptionData[oneTimeKey].price || 0;
    }
  }
  
  // Format price (price is in cents)
  const formattedPrice = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(price / 100);
  
  // Update button text
  continueBtn.textContent = `Add to cart | ${formattedPrice.split('.')[0]}`;
}

// Get subscription data helper function
function getSubscriptionData() {
  const dataScript = document.getElementById('product__data');
  if (dataScript) {
    try {
      return JSON.parse(dataScript.textContent);
    } catch (e) {
      console.error('Error parsing subscription data:', e);
    }
  }
  return null;
}

// Get macaron count for variant size (for show_variants products)
function getMacaronsForVariant(variantValue) {
  const variantLower = variantValue.toLowerCase();
  
  // Map variant values to macaron counts based on requirements
  if (variantLower.includes('12')) {
    return 12;
  } else if (variantLower.includes('24')) {
    return 24;
  } else if (variantLower.includes('48')) {
    return 48;
  } else if (variantLower.includes('4') && variantLower.includes('tier')) {
    return 36;
  } else if (variantLower.includes('6') && variantLower.includes('tier')) {
    return 84;
  } else if (variantLower.includes('10') && variantLower.includes('tier')) {
    return 240;
  }else if (variantLower.includes('favor box')) {
    return 3;
  }else if (parseInt(variantLower.replace(/[^0-9]/g, '')) > 0) {
    return parseInt(variantLower.replace(/[^0-9]/g, ''));
  }
  
  // Fallback to default if no match
  console.log('Unknown variant for macaron count:', variantValue, 'using default 24');
  return 24;
}

// Initialize date picker functionality
function initializeDatePicker(namePrefix) {
  const stepModal = document.getElementById(namePrefix + 'step-modal');
  if (!stepModal) return;
  
  const step2Panel = stepModal.querySelector('.step-panel[data-step="2"]');
  if (!step2Panel) return;
  
  const dateInput = step2Panel.querySelector('.date-picker');
  const dateContainer = step2Panel.querySelector('.date-picker-container');
  const continueBtn = step2Panel.querySelector('.step-continue-btn');
  
  if (!dateInput || !continueBtn) return;
  
  // Set minimum date dynamically (2 days from now) for better iPhone compatibility
  const today = new Date();
  const minDate = new Date(today.getTime() + (1 * 24 * 60 * 60 * 1000)); // Add 2 days
  const minDateString = minDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
  dateInput.setAttribute('min', minDateString);
  
  console.log('Set min date for date picker:', minDateString);
  
  // Add event listeners for date input changes
  dateInput.addEventListener('change', function() {
    updateDateContinueButton();
  });
  
  dateInput.addEventListener('input', function() {
    updateDateContinueButton();
  });
  
  // Make date input clickable to open calendar (for mobile devices)
  dateInput.addEventListener('click', function() {
    // Check if "yes" is selected first
    const yesBtn = step2Panel.querySelector('.step-option-btn[data-value="yes"].selected');
    if (yesBtn) {
      // Focus the input to trigger calendar on mobile
      this.focus();
      // For desktop browsers, try to show the picker
      if (this.showPicker) {
        this.showPicker();
      }
    }
  });
  
  // Disable date input when "yes" is not selected
  function updateDateInputState() {
    const yesBtn = step2Panel.querySelector('.step-option-btn[data-value="yes"].selected');
    if (yesBtn) {
      dateInput.disabled = false;
      dateInput.style.opacity = '1';
      dateInput.style.cursor = 'pointer';
    } else {
      dateInput.disabled = true;
      dateInput.style.opacity = '0.5';
      dateInput.style.cursor = 'not-allowed';
      dateInput.value = ''; // Clear date when disabled
    }
  }
  
  // Function to update continue button based on date selection
  function updateDateContinueButton() {
    const yesBtn = step2Panel.querySelector('.step-option-btn[data-value="yes"].selected');
    const hasDate = dateInput.value && dateInput.value.trim() !== '';
    
    if (yesBtn && hasDate) {
      // Check if selected date is at least 2 days from today
      const selectedDate = new Date(dateInput.value);
      const today = new Date();
      const minDate = new Date(today.getTime() + (1 * 24 * 60 * 60 * 1000)); // Add 2 days
      
      // Reset time to compare only dates
      selectedDate.setHours(0, 0, 0, 0);
      minDate.setHours(0, 0, 0, 0);
      
      if (selectedDate >= minDate) {
        // Valid date selected - enable continue button
        continueBtn.disabled = false;
        continueBtn.style.background = 'white';
        continueBtn.style.color = '#333';
        continueBtn.style.borderColor = '#333';
        continueBtn.classList.add('active-state');
        continueBtn.textContent = 'Continue';
        console.log('Valid date selected:', dateInput.value);
      } else {
        // Invalid date selected (less than 2 days from today) - disable continue button
        continueBtn.disabled = true;
        continueBtn.style.background = '#f0f0f0';
        continueBtn.style.color = '#999';
        continueBtn.style.borderColor = '#ccc';
        continueBtn.classList.remove('active-state');
        
        // Format the minimum date for display
        const minDateFormatted = minDate.toLocaleDateString('en-US', { 
          month: 'short', 
          day: 'numeric' 
        });
        continueBtn.textContent = `Available from ${minDateFormatted}`;
        console.log('Invalid date selected:', dateInput.value, 'Min date:', minDate.toISOString().split('T')[0]);
      }
    } else if (yesBtn && !hasDate) {
      // "Yes" is selected but no date chosen - disable continue button
      continueBtn.disabled = true;
      continueBtn.style.background = '#f0f0f0';
      continueBtn.style.color = '#999';
      continueBtn.style.borderColor = '#ccc';
      continueBtn.classList.remove('active-state');
      continueBtn.textContent = 'Continue';
    }
    // If "No" is selected, the button state is handled in the main step option logic
  }
  
  // Monitor for changes in step option selections
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        updateDateInputState();
        updateDateContinueButton();
      }
    });
  });
  
  // Observe changes to step option buttons
  const stepOptionBtns = step2Panel.querySelectorAll('.step-option-btn');
  stepOptionBtns.forEach(btn => {
    observer.observe(btn, { attributes: true });
  });
  
  // Initial state setup
  updateDateInputState();
  updateDateContinueButton();
}

// Initialize gift note functionality
function initializeGiftNote(namePrefix) {
  const stepModal = document.getElementById(namePrefix + 'step-modal');
  if (!stepModal) return;
  
  const step3Panel = stepModal.querySelector('.step-panel[data-step="3"]');
  if (!step3Panel) return;
  
  const giftNoteInput = step3Panel.querySelector('.gift-note-text');
  const giftContainer = step3Panel.querySelector('.gift-note-container');
  const continueBtn = step3Panel.querySelector('.step-continue-btn');
  
  if (!giftNoteInput || !continueBtn) return;
  
  // Add event listeners for gift note input changes
  giftNoteInput.addEventListener('input', function() {
    updateGiftNoteContinueButton();
  });
  
  giftNoteInput.addEventListener('change', function() {
    updateGiftNoteContinueButton();
  });
  
  // Disable gift note input when "yes" is not selected
  function updateGiftNoteInputState() {
    const yesBtn = step3Panel.querySelector('.step-option-btn[data-value="yes"].selected');
    if (yesBtn) {
      giftNoteInput.disabled = false;
      giftNoteInput.style.opacity = '1';
      giftNoteInput.style.cursor = 'text';
    } else {
      giftNoteInput.disabled = true;
      giftNoteInput.style.opacity = '0.5';
      giftNoteInput.style.cursor = 'not-allowed';
      giftNoteInput.value = ''; // Clear gift note when disabled
    }
  }
  
  // Function to update continue button based on gift note input
  function updateGiftNoteContinueButton() {
    const yesBtn = step3Panel.querySelector('.step-option-btn[data-value="yes"].selected');
    const hasText = giftNoteInput.value && giftNoteInput.value.trim() !== '';
    
    if (yesBtn && hasText) {
      // "Yes" is selected and text is entered - enable continue button
      continueBtn.disabled = false;
      continueBtn.style.background = 'white';
      continueBtn.style.color = '#333';
      continueBtn.style.borderColor = '#333';
      continueBtn.classList.add('active-state');
    } else if (yesBtn && !hasText) {
      // "Yes" is selected but no text entered - disable continue button
      continueBtn.disabled = true;
      continueBtn.style.background = '#f0f0f0';
      continueBtn.style.color = '#999';
      continueBtn.style.borderColor = '#ccc';
      continueBtn.classList.remove('active-state');
    }
    // If "No" is selected, the button state is handled in the main step option logic
  }
  
  // Monitor for changes in step option selections
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        updateGiftNoteInputState();
        updateGiftNoteContinueButton();
      }
    });
  });
  
  // Observe changes to step option buttons
  const stepOptionBtns = step3Panel.querySelectorAll('.step-option-btn');
  stepOptionBtns.forEach(btn => {
    observer.observe(btn, { attributes: true });
  });
  
  // Initial state setup
  updateGiftNoteInputState();
  updateGiftNoteContinueButton();
}


function scrollToStartOfPrintImages(namePrefix) {
  const stepModal = document.getElementById(namePrefix + 'step-modal');
  if (!stepModal) return;
  const printImagesWrapper = stepModal.querySelector('.print-images-wrapper');
  if (!printImagesWrapper) return;

  printImagesWrapper.scrollTo({
    left: 0,
    behavior: 'smooth'
  });
}

// Initialize custom print image functionality
  function initializeCustomPrintImages(namePrefix) {
    const stepModal = document.getElementById(namePrefix + 'step-modal');
    if (!stepModal) return;
    
    const allCustomPrint = stepModal.querySelectorAll('.custom-print-image');
    
    allCustomPrint.forEach(print => {
      print.addEventListener('click', function() {
        allCustomPrint.forEach(printItem => {
          printItem.classList.remove('active');
        });
        
        this.classList.add('active');
        
        const imgSrc = this.src;
        const parentDiv = this.closest('.step-panel');
        
        if (parentDiv) {
          const customMsg = parentDiv.querySelector('.custom-image-selection-msg');
          const fileInput = parentDiv.querySelector('input#' + namePrefix + 'print_file');
          const continueBtn = parentDiv.querySelector('.step-continue-btn');
          const previewDiv = parentDiv.querySelector('.upload-preview-container');
          const uploadBtn = parentDiv.querySelector('label.upload-btn');
          const stepYes = parentDiv.querySelector('.step-option-btn[data-value="yes"]');
          const centerText = stepModal.dataset.center;
          const leftText = stepModal.dataset.left;
          const rightText = stepModal.dataset.right;
          if(stepYes) {
            stepYes.click();
          }
          
          if (fileInput) {
            fileInput.value = imgSrc;
            
            if (customMsg) {
              customMsg.style.display = 'block';
            }

            if (continueBtn) {
              continueBtn.removeAttribute('disabled');
              continueBtn.innerHTML = 'Continue'
              continueBtn.style.background = 'white';
              continueBtn.style.color = '#333';
              continueBtn.style.borderColor = '#333';
              continueBtn.classList.add('active-state');
            }
            
            if (previewDiv) {
              previewDiv.classList.add('not-to-show-child');
            }
            
            if (uploadBtn) {
              uploadBtn.innerHTML = `<span class="not-clickable-link">${leftText} </span><span>${centerText}</span><span class="not-clickable-link"> ${rightText}</span>`;
            }
          }
        }
      });
    });
  }

    // Initialize drag and swipe functionality for print-images-wrapper
  function initializeDragSwipe() {
    const printImagesWrapper = document.querySelector('#step-modal .print-images-wrapper');
    if (!printImagesWrapper) return;
    
    let isDragging = false;
    let startX = 0;
    let scrollLeft = 0;
    let velocity = 0;
    let lastX = 0;
    let lastTime = 0;
    let animationFrame = null;
    
    // Add cursor styles for better UX
    printImagesWrapper.style.cursor = 'grab';
    printImagesWrapper.style.userSelect = 'none';
    
    // Add smooth scrolling behavior to CSS
    printImagesWrapper.style.scrollBehavior = 'smooth';
    
    // Add enhanced styling for better drag experience
    printImagesWrapper.style.transition = 'transform 0.1s ease-out';
    
    // Add CSS for dragging state
    const style = document.createElement('style');
    style.textContent = `
      .print-images-wrapper.dragging {
        cursor: grabbing !important;
      }
    `;
    document.head.appendChild(style);
    
    // Add visual feedback for dragging state
    printImagesWrapper.addEventListener('mousedown', () => {
      printImagesWrapper.classList.add('dragging');
    });
    
    printImagesWrapper.addEventListener('mouseup', () => {
      printImagesWrapper.classList.remove('dragging');
    });
    
    printImagesWrapper.addEventListener('mouseleave', () => {
      printImagesWrapper.classList.remove('dragging');
    });
    
    // Mouse events for desktop
    printImagesWrapper.addEventListener('mousedown', (e) => {
      isDragging = true;
      startX = e.pageX - printImagesWrapper.offsetLeft;
      scrollLeft = printImagesWrapper.scrollLeft;
      printImagesWrapper.style.cursor = 'grabbing';
      printImagesWrapper.style.scrollBehavior = 'auto';
      
      // Prevent text selection
      e.preventDefault();
    });
    
    printImagesWrapper.addEventListener('mouseleave', () => {
      isDragging = false;
      printImagesWrapper.style.cursor = 'grab';
    });
    
    printImagesWrapper.addEventListener('mouseup', () => {
      isDragging = false;
      printImagesWrapper.style.cursor = 'grab';
      printImagesWrapper.style.scrollBehavior = 'smooth';
      
      // Apply momentum scrolling
      if (Math.abs(velocity) > 0.5) {
        applyMomentum();
      }
    });
    
    printImagesWrapper.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      
      e.preventDefault();
      const x = e.pageX - printImagesWrapper.offsetLeft;
      const walk = (x - startX) * 2; // Multiply for faster scrolling
      printImagesWrapper.scrollLeft = scrollLeft - walk;
      
      // Calculate velocity for momentum
      const currentTime = Date.now();
      if (lastTime > 0) {
        velocity = (printImagesWrapper.scrollLeft - lastX) / (currentTime - lastTime);
      }
      lastX = printImagesWrapper.scrollLeft;
      lastTime = currentTime;
    });
    
    // Touch events for mobile
    printImagesWrapper.addEventListener('touchstart', (e) => {
      isDragging = true;
      startX = e.touches[0].pageX - printImagesWrapper.offsetLeft;
      scrollLeft = printImagesWrapper.scrollLeft;
      printImagesWrapper.style.scrollBehavior = 'auto';
      printImagesWrapper.classList.add('dragging');
      velocity = 0;
      lastX = printImagesWrapper.scrollLeft;
      lastTime = Date.now();
    }, { passive: true });
    
    printImagesWrapper.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      
      const x = e.touches[0].pageX - printImagesWrapper.offsetLeft;
      const walk = (x - startX) * 2; // Multiply for faster scrolling
      printImagesWrapper.scrollLeft = scrollLeft - walk;
      
      // Calculate velocity for momentum
      const currentTime = Date.now();
      if (lastTime > 0) {
        velocity = (printImagesWrapper.scrollLeft - lastX) / (currentTime - lastTime);
      }
      lastX = printImagesWrapper.scrollLeft;
      lastTime = currentTime;
    }, { passive: true });
    
    printImagesWrapper.addEventListener('touchend', () => {
      isDragging = false;
      printImagesWrapper.style.scrollBehavior = 'smooth';
      printImagesWrapper.classList.remove('dragging');
      
      // Apply momentum scrolling
      if (Math.abs(velocity) > 0.5) {
        applyMomentum();
      }
    });
    
    // Momentum scrolling function
    function applyMomentum() {
      if (animationFrame) {
        cancelAnimationFrame(animationFrame);
      }
      
      const friction = 0.95;
      const minVelocity = 0.1;
      
      function animate() {
        if (Math.abs(velocity) < minVelocity) {
          return;
        }
        
        printImagesWrapper.scrollLeft -= velocity;
        velocity *= friction;
        
        animationFrame = requestAnimationFrame(animate);
      }
      
      animate();
    }
    
    // Prevent default touch behavior on parent elements
    printImagesWrapper.addEventListener('touchstart', (e) => {
      e.stopPropagation();
    });
    
    printImagesWrapper.addEventListener('touchmove', (e) => {
      e.stopPropagation();
    });
}
